/* -- MaxMart Review Badges -- Global star ratings on product titles & cards -- */
(function() {
  'use strict';
  var API = 'https://api.maxmart.it/api/reviews/';
  var cache = {};
  var CARD_ROW_HEIGHT = '18px';

  function starsSVG(avg, size) {
    size = size || 14;
    var html = '';
    for (var i = 1; i <= 5; i++) {
      var fill, opacity = '1';
      if (avg >= i) { fill = '#f59e0b'; }
      else if (avg >= i - 0.5) { fill = '#f59e0b'; opacity = '0.55'; }
      else { fill = '#d1d5db'; }
      html += '<svg width="' + size + '" height="' + size + '" viewBox="0 0 20 20" style="vertical-align:middle;opacity:' + opacity + '"><polygon points="10,1.5 12.5,7 18.5,7.5 14,11.5 15.5,17.5 10,14 4.5,17.5 6,11.5 1.5,7.5 7.5,7" fill="' + fill + '"/></svg>';
    }
    return html;
  }

  function createBadge(avg, total, isCard) {
    if (!total || total === 0) return '';
    var size = isCard ? 13 : 15;
    return '<span style="display:inline-flex;align-items:center;gap:4px">' +
      '<span style="display:inline-flex;align-items:center;gap:0;letter-spacing:0">' + starsSVG(avg, size) + '</span>' +
      '<span style="font-size:' + (isCard ? '12' : '14') + 'px;color:rgba(0,0,0,0.55)">' +
      (isCard ? '(' + total + ')' : avg.toFixed(1) + ' (' + total + ' recension' + (total === 1 ? 'e' : 'i') + ')') +
      '</span></span>';
  }

  function fetchReview(handle, cb) {
    if (cache[handle]) { cb(cache[handle]); return; }
    var x = new XMLHttpRequest();
    x.open('GET', API + encodeURIComponent(handle));
    x.onload = function() {
      if (x.status === 200) {
        try {
          var d = JSON.parse(x.responseText);
          var result = { avg: d.average || (d.summary && d.summary.average) || 0, total: d.total || (d.summary && d.summary.total) || 0 };
          cache[handle] = result;
          cb(result);
        } catch(e) { cb(null); }
      } else { cb(null); }
    };
    x.onerror = function() { cb(null); };
    x.send();
  }

  function addProductPageBadge() {
    var titleDiv = document.querySelector('.product__title');
    if (!titleDiv || titleDiv.querySelector('.mm-rating-pdp')) return;
    var handle = window.location.pathname.split('/products/')[1];
    if (!handle) return;
    handle = handle.split('?')[0].split('#')[0];
    fetchReview(handle, function(data) {
      if (!data || !data.total) return;
      var badge = createBadge(data.avg, data.total, false);
      if (badge) {
        var div = document.createElement('div');
        div.className = 'mm-rating-pdp';
        div.style.cssText = 'margin:8px 0 4px;cursor:pointer';
        div.innerHTML = badge;
        div.addEventListener('click', function() {
          var section = document.querySelector('#maxmart-reviews, [data-mm-reviews], .mm-reviews-section, .mm-reviews, .section-product-reviews, [id*=product-reviews]');
          if (section) section.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
        titleDiv.appendChild(div);
      }
    });
  }

  function addCardBadges() {
    var cards = document.querySelectorAll('.card-wrapper, .card--standard');
    var handled = [];
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      if (card.querySelector('.mm-rating-card')) continue;
      var link = card.querySelector('a[href*="/products/"]');
      if (!link) continue;
      var href = link.getAttribute('href') || '';
      var match = href.match(/\/products\/([^?#/]+)/);
      if (!match) continue;
      var handle = match[1];

      /* Insert placeholder immediately for alignment (above title) */
      var heading = card.querySelector('.card__heading');
      if (heading && !heading.parentElement.querySelector('.mm-rating-card')) {
        var ph = document.createElement('div');
        ph.className = 'mm-rating-card';
        ph.style.cssText = 'min-height:' + CARD_ROW_HEIGHT + ';display:flex;align-items:center;margin:0 0 3px;line-height:1';
        ph.innerHTML = '\u00a0'; /* non-breaking space so theme does not hide it */
        heading.insertAdjacentElement('beforebegin', ph);
        handled.push({ card: card, handle: handle, placeholder: ph });
      }
    }
    var delay = 0;
    for (var j = 0; j < handled.length; j++) {
      (function(item, d) {
        setTimeout(function() {
          fetchReview(item.handle, function(data) {
            if (!data || !data.total) return;
            var badge = createBadge(data.avg, data.total, true);
            if (badge && item.placeholder) {
              item.placeholder.innerHTML = badge;
            }
          });
        }, d);
      })(handled[j], delay);
      delay += 80;
    }
  }

  function init() {
    addProductPageBadge();
    addCardBadges();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Re-run for dynamically loaded content */
  var observer = new MutationObserver(function(mutations) {
    var hasNewCards = false;
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes.length > 0) {
        for (var j = 0; j < mutations[i].addedNodes.length; j++) {
          var node = mutations[i].addedNodes[j];
          if (node.nodeType === 1 && (node.querySelector && (node.querySelector('.card-wrapper') || node.classList.contains('card-wrapper')))) {
            hasNewCards = true;
            break;
          }
        }
      }
      if (hasNewCards) break;
    }
    if (hasNewCards) {
      setTimeout(addCardBadges, 300);
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
